export const SEARCH_ITEM_ICON_SIZE = 40
